import React from "react";
import secureIcon from "../../../assets/icons/secure_dash.svg";
import reportIcon from "../../../assets/icons/report_dash.svg";
import retestIcon from "../../../assets/icons/retest_dash.svg";
import activeIcon from "../../../assets/icons/active_dash.svg";

type CardProps = {
  title: string;
  value: number;
  helper?: string;
  iconSrc: string;
  iconBg: string;
};

const SummaryCard = ({ title, value, helper, iconSrc, iconBg }: CardProps) => {
  return (
    <div className="flex w-full items-center gap-4 rounded-xl border border-gray-200 bg-white p-6 shadow-sm">
      <div
        className="flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-2xl"
        style={{ backgroundColor: iconBg }}
      >
        <img src={iconSrc} alt={title} className="h-6 w-6" />
      </div>
      <div className="py-1">
        <p className="text-sm font-medium text-gray-600">{title}</p>
        <p className="mt-2 text-3xl font-semibold text-gray-900">
          {Number(value || 0).toLocaleString()}
        </p>
        {helper && (
          <p className="mt-1 text-xs font-medium text-gray-500">{helper}</p>
        )}
      </div>
    </div>
  );
};

type TopSummaryCardsProps = {
  activePrograms: number;
  pendingReports: number;
  pendingRetests: number;
  activeResearchers: number;
  helpers?: {
    activePrograms?: string;
    pendingReports?: string;
    pendingRetests?: string;
    activeResearchers?: string;
  };
};

const TopSummaryCards = ({
  activePrograms,
  pendingReports,
  pendingRetests,
  activeResearchers,
  helpers
}: TopSummaryCardsProps) => {
  return (
    <div className="grid grid-cols-1 gap-5 px-4 sm:grid-cols-2 lg:grid-cols-4">
      <SummaryCard
        title="Active Programs"
        value={activePrograms}
        helper={helpers?.activePrograms}
        iconSrc={secureIcon}
        iconBg="#DBEAFE"
      />
      <SummaryCard
        title="Pending Reports"
        value={pendingReports}
        helper={helpers?.pendingReports}
        iconSrc={reportIcon}
        iconBg="#FFEDD5"
      />
      <SummaryCard
        title="Pending Retest"
        value={pendingRetests}
        helper={helpers?.pendingRetests}
        iconSrc={retestIcon}
        iconBg="#FEE2E2"
      />
      <SummaryCard
        title="Active Researchers"
        value={activeResearchers}
        helper={helpers?.activeResearchers}
        iconSrc={activeIcon}
        iconBg="#F3E8FF"
      />
    </div>
  );
};

export default TopSummaryCards;


